import { base } from "./base";
import { loaderEndHook, loaderErrorHook, loaderStartHook } from "./hooks/loader";

// Public instance: loader only, no auth, no token-refresh hooks.
// Intentionally kept free of tokenRefresh.ts imports so hook files can
// safely import this without creating a circular dependency.
export const httpPublic2 = base.extend({
  hooks: {
    afterResponse: [loaderEndHook],
    beforeError: [loaderErrorHook],
    beforeRequest: [loaderStartHook],
  },
});
